<template>
  <div>
      <video autoplay muted loop class="hover_video" src="@/assets/video/nyapitcuan.mp4"></video>
      <p class="description pd-top-40">
        MNC Kapital Indonesia kembali mengadakan kompetisi cerdas cermat virtual seputar keuangan, ekonomi, dan current affairs dengan nama Nyapit Cuan 2. Ayo ikuti kompetisinya segera persiapkan diri Anda untuk mendapatkan berbagai hadiah menarik.
      </p>
      <!-- <p class="link description mg-top-20" @click="movePage()">Selengkapnya</p> -->
  </div>
</template>

<script>
export default {
  name: 'Nyapit',
  data () {
    return {

    }
  },
  methods: {
    movePage() {
      this.$router.push('/nyapit-cuan')
    }
  }
}
</script>
